import { Component } from "react";
import { withRouter } from "react-router-dom";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import moment from "moment";
import CustomizedTextField from "../../Input/CustomizedTextField";

class QuoteCard extends Component {
    render() {
        return (
            <div className="col-lg-4 col-md-6 col-sm-12 col-12">
                <Card className="card without-padding card-margin-top">
                    <CardHeader
                        style={{ color: "rgb(117, 117, 117)" }}
                        title={this.props.currentQuote.name}
                        className="card-header-padding-bottom"
                    />
                    <CardContent className="without-padding card-content-left-align">
                        <div className="col-lg-12 col-md-12 col-sm-12 col-12 control-margin-top">
                            <CustomizedTextField
                                id="quote-code"
                                label="Code"
                                className="full_size light-disabled"
                                value={this.props.currentQuote.code}
                            />
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12 col-12 control-margin-top">
                            <CustomizedTextField
                                id="company_name"
                                label="Agence"
                                className="full_size light-disabled"
                                value={this.props.currentQuote.company_id.name}
                            />
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12 col-12 control-margin-top">
                            <CustomizedTextField
                                id="state"
                                label="Statut"
                                className="full_size light-disabled"
                                value={this.props.currentQuote.quote_state}
                            />
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12 col-12 control-margin-top">
                            <CustomizedTextField
                                id="date"
                                label="Date de demande de devis"
                                className="full_size light-disabled"
                                value={moment(this.props.currentQuote.date_quote_asked, "YYYY-MM-DD").format(
                                    "DD/MM/YYYY"
                                )}
                            />
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12 col-12 control-margin-top">
                            <CustomizedTextField
                                id="business-user"
                                label="Commercial"
                                className="full_size light-disabled"
                                value={this.props.currentQuote.business_user_id.name}
                            />
                        </div>
                    </CardContent>
                </Card>
            </div>
        );
    }
}

export default withRouter(QuoteCard);
